import { PRODUCT_CATEGORIES, PRODUCT_TYPES } from "@sdk-point/talisis";

export const getMembershipFromCart = (cartItems) => {
    return cartItems.find(item =>
        item.product_category_id === PRODUCT_CATEGORIES.STANDALONE &&
        item.product_type_id === PRODUCT_TYPES.MEMBRESIA
    );
};